import React,{useState} from 'react';
import './Section4.css';
import Card from './Card';
import moreLogo from '../../static/page1-img/drop_down.svg';
function Section4() {
   const [projectLists] = useState([
    {title:"Java Spring Boot, React js and MongoDB",desc:"Employee Management System",link:"https://github.com/anshul2807/Employee-Management-System-Frontend",color:"#54B0F2"},
     {title:"React js, Node js and MongoDb",desc:"FAQ Chat Bot",link:"https://github.com/anshul2807/FAQ-chat-Bot-server",color:"#54B0F2"},
     {title:"Node js and Socket.io",desc:"Active Chat Monitoring App.",link:"https://anshul2807.github.io/webdevEditor/",color:"#54B0F2"},
     {title:"HTML, CSS and Node js",desc:"Online Web Editor",link:"https://anshul2807.github.io/webdevEditor/",color:"#FF4BCD"},
     {title:"React js and Styled Components",desc:"Advanced Note App",link:"https://anshul2807.github.io/AdvanceNoteApp/",color:"#FF4BCD"},
     {title:"Machine learning, React js and Node js",desc:"Music recommendation system",link:"https://github.com/anshul2807/MusicRecommendation_UI",color:"#FF4BCD"},
   ])
  const handleRotation=(e)=>{
    let logo=e.target;
    logo.classList.add("rotateLogo");
    setTimeout(()=>{
      logo.classList.remove("rotateLogo");
    },1000)
    
  }
  return (
    <div className='section4' id='section_projects'>
        <div className='section4__1'>
          <p>Major Project's</p>
        </div>
        <div className='section4__2'>
          {projectLists.map((list,ind) => <Card key={ind} title={list.title} desc={list.desc} color={list.color} link={list.link} />)}
        </div>
        <div className='section4__3'>
          <a href="https://github.com/anshul2807?tab=repositories">
            <img onClick={handleRotation} src={moreLogo} alt="more" />
          </a>
        </div>
        
    </div>
  )
}

export default Section4